import {
    delay, takeEvery, put, Effect,
} from "redux-saga/effects";


import { NotificationActionType, IPushNotificationAction, removeNotification } from "./notification.actions";

function* onPush(action: IPushNotificationAction): IterableIterator<Effect> {
    const { notification, autoRemove } = action;

    if (autoRemove === false) {
        return;
    }

    yield delay(autoRemove);
    yield put(removeNotification(notification.timeStamp));
}

export const notificationSagas = [
    takeEvery(NotificationActionType.PUSH, onPush),
];
